import PropTypes from 'prop-types'
import cn from '../modules/cn'

function PasswordStrengthTester({ value, total }) {
  if (value === null) {
    return null
  }

  return (
    <div className="flex flex-row space-x-1">
      {Array.from({ length: total }, (x, i) => i).map((step) => {
        const percentage = (100 * value) / total
        let className = 'bg-red-500'
        if (percentage > 25) {
          className = 'bg-orange-500'
        }
        if (percentage > 50) {
          className = 'bg-yellow-500'
        }
        if (percentage > 75) {
          className = 'bg-green-500'
        }
        return (
          <div key={`step-${step}`} className={cn('bg-gray-300 w-5 h-1 rounded', value > step && className)} />
        )
      })}
    </div>
  )
}

PasswordStrengthTester.propTypes = {
  value: PropTypes.number,
  total: PropTypes.number,
}

PasswordStrengthTester.defaultProps = {
  value: null,
  total: 4,
}

export default PasswordStrengthTester
